export default __webpack_public_path__ + "static/media/user.1caf1138.svg";